export default __webpack_public_path__ + "static/media/logo.7b9f223e.png";